export type env = "local" | "test" | "stage" | "prod";

declare global {
	interface Window {
		release: string;
		envName: string;
		tenant: string;
	}
}

export const getEnv = () => {
	const tenant = getTenant();

	return {
		release: window.release,
		envName: getEnvironment(),
		tenant,
		hasProfiles: tenant === "akt",
	};
};

export const getTenant = (): "akt" | "ruter" => {
	switch (window.tenant) {
		case "akt":
			return "akt";
		case "ruter":
			return "ruter";
		default:
			throw new Error(`Invalid tenant=${window.tenant}`);
	}
};

const getEnvironment = (): env => {
	if (window.envName === "prod") {
		return "prod";
	}
	if (window.envName === "stage") {
		return "stage";
	}
	if (window.envName === "test") {
		return "test";
	}
	return "local";
};
